import React, { createContext, useContext, useMemo, useEffect, useState } from "react";
const AuthStateContext = createContext(null);
import { useLocation, useNavigate } from "react-router-dom";
import { menuList } from "components/layout/menuListItem";
import cookie from "js-cookie";
import store from "store/store-config";
import { setCookiesCurrentPage } from "utils/functions";

export function useAuth() {
  return useContext(AuthStateContext);
}

interface Props {
  children: JSX.Element;
}

function AuthProvider({ children }: Props) {
  const [menuActive, setMenuActive] = useState([]);
  const [pathActive, setPathActive] = useState(null);
  const router = useLocation();
  const navigate = useNavigate();

  const unauthorizedPage = "/unauthorized";
  const isUnknownRole = "Desconhecido";

  const getStoreUserRole = store.getState().UserSession.userData.role;

  let allowed = true;
  const role = getStoreUserRole;

  const verifyRoles = (router.pathname.startsWith(pathActive) || router.pathname.includes("form")) && !menuActive.includes(role);

  if (verifyRoles) {
    setCookiesCurrentPage("lobby");
    allowed = false;
  }

  const setRoutes = (item) => {
    setMenuActive(item.role);
    setPathActive(item.path);
    cookie.set("menuItemActive", item.id);
  };

  useEffect(() => {
    const routeActive = router.pathname;
    menuList.forEach((item) => {
      if (item.Items === undefined && routeActive === item.path) {
        setRoutes(item);
      }
      item.Items?.forEach((subItems) => {
        const id = "[id]";
        if (routeActive === subItems.path) {
          setRoutes(subItems);
        }
        if (subItems.path.includes(id) && routeActive.includes("/form/")) {
          setRoutes(subItems);
        }
      });
    });

    if (verifyRoles && role !== isUnknownRole) {
      navigate("/private/lobby");
      setCookiesCurrentPage("lobby");
    }
  }, [router, menuActive, pathActive]);

  if (role === isUnknownRole && !router.pathname.startsWith(unauthorizedPage)) {
    navigate(unauthorizedPage);
  }

  const contextValue = useMemo(() => [allowed, role], [allowed, role]);
  const ComponentToRender = allowed ? children : null;

  return <AuthStateContext.Provider value={contextValue}>{ComponentToRender}</AuthStateContext.Provider>;
}

export { AuthProvider };
